/**
 * Microsoft Clarity client API helpers.
 * @see https://learn.microsoft.com/en-us/clarity/setup-and-installation/clarity-api
 */

declare global {
  interface Window {
    clarity?: (action: string, ...args: (string | string[])[]) => void
  }
}

function getClarity(): Window['clarity'] {
  return typeof window !== 'undefined' ? window.clarity : undefined
}

/**
 * Set custom identifiers for the session.
 * @param userId - Required. Your custom user/session identifier (e.g. user sub, not PII).
 */
export function clarityIdentify(userId: string): void {
  const clarity = getClarity()
  if (!clarity) return
  clarity('identify', userId)
}
/**
 * Set consent for the session.
 */
export function clarityConsent(): void {
  const clarity = getClarity()
  if (!clarity) return
  clarity('consent')
}
/**
 * Set custom tags for filtering in Clarity (Filters, Dashboard, Recordings).
 * Value can be a string or array of strings.
 */
export function claritySet(key: string, value: string | string[]): void {
  const clarity = getClarity()
  if (!clarity) return
  clarity('set', key, value)
}

/**
 * Track a custom event (appears with Smart events in Clarity).
 */
export function clarityEvent(eventName: string): void {
  const clarity = getClarity()
  if (!clarity) return
  clarity('event', eventName)
}
